export default [
	{//系统用户
		path: 'users',
		name: 'm_manage_user',
		props: route => route.params,
		component: () => import('@/pages/system/sysuser_list')
	},
	{//字典类型
		path: 'dic/type',
		name: 'm_dic_type',
		props: route => route.params,
		component: () => import('@/pages/system/dic_type_list')
	},
	{//字典值管理
		path: 'dic/info',
		name: 'm_dic_info',
		props: route => route.params,
		component: () => import('@/pages/system/dic_info_list')
	}, {  // 自定义编号规则
		path: 'numberRule',
		name: 'm_custom_seqnumber',
		props: route => route.params,
		component: () => import('@/pages/system/number_rule')
	}, {  // 上架渠道管理
		path: 'channel',
		name: 'm_channel_info',
		props: route => route.params,
		component: () => import('@/pages/system/channel_list')
	}, {  // 通知公告管理
		path: 'platform_config',
		name: 'm_system_platform_config',
		props: route => route.params,
		component: () => import('@/pages/system/platform_config')
	}, {  // 通知公告管理
		path: 'notice',
		name: 'm_system_notice',
		props: route => route.params,
		component: () => import('@/pages/system/system_notice_list')
	}, {  // 新手入门管理
		path: 'guide',
		name: 'm_system_guide',
		props: route => route.params,
		component: () => import('@/pages/system/system_guide_list')
	}, {  // 规则规范管理
		path: 'rule',
		name: 'm_rule_manage',
		props: route => route.params,
		component: () => import('@/pages/system/rule_manage_list')
	}, {  // 单页管理
		path: 'single-page',
		name: 'm_system_single_page',
		props: route => route.params,
		component: () => import('@/pages/system/system_single_page_list')
	}
];
